/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowReleaseLayoutsDto } from '../../models/workflow-release-layouts-dto';

export interface ClientManagementGetWorkflowReleaseLayoutsGet$Params {
  release_uuid?: string;
}

export function clientManagementGetWorkflowReleaseLayoutsGet(http: HttpClient, rootUrl: string, params?: ClientManagementGetWorkflowReleaseLayoutsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowReleaseLayoutsDto>>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetWorkflowReleaseLayoutsGet.PATH, 'get');
  if (params) {
    rb.query('release_uuid', params.release_uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowReleaseLayoutsDto>>;
    })
  );
}

clientManagementGetWorkflowReleaseLayoutsGet.PATH = '/ClientManagement/GetWorkflowReleaseLayouts';
